import { LOCALE_ID, NgModule } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { WindowRef } from './_helpers/windowref';
import { httpInterceptorProviders } from './_helpers/http-interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import localeId from '@angular/common/locales/id';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeId);

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot([]),
        HttpClientModule,
        AppRoutingModule,
        AppLayoutModule,
        LoggerModule.forRoot({
            serverLoggingUrl: environment.weblogUrl,
            level: NgxLoggerLevel.TRACE,
            serverLogLevel: NgxLoggerLevel.ERROR,
            disableConsoleLogging: false
        }),
    ],
    providers: [
        httpInterceptorProviders,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        WindowRef,
        DialogService,
        { provide: LOCALE_ID, useValue: 'id-ID' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
